"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenWidget = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var lodash_1 = require("lodash");
var WidgetManager_1 = require("Project/QwilrEditor/WidgetManager");
var EditorTypes_1 = require("Project/QwilrEditor/EditorTypes");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var LegacyCombobox_1 = __importDefault(require("Common/LegacyCombobox/LegacyCombobox"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var Types_1 = require("Tokens/Types");
var Types_2 = require("@CommonFrontendBackend/Tokens/Types");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var classnames_1 = __importDefault(require("classnames"));
var c = (0, BemBuilder_1.default)("token-widget");
var TokenWidget = (function (_super) {
    __extends(TokenWidget, _super);
    function TokenWidget() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.hasTriggeredWidgetEvent = false;
        _this.setHasTriggeredWidgetEvent = function () {
            _this.hasTriggeredWidgetEvent = true;
        };
        _this.renderEntry = function (entry) {
            return react_1.default.createElement(kaleidoscope_1.Token, { type: entry.data.dataType === Types_2.TokenDataType.List ? "list" : "text", name: entry.label });
        };
        _this.renderInput = function (props) {
            var _a;
            var onChange = props.onChange, onKeyDown = props.onKeyDown, onBlur = props.onBlur, rest = __rest(props, ["onChange", "onKeyDown", "onBlur"]);
            return (react_1.default.createElement("span", { className: c("wrapper") },
                react_1.default.createElement("span", { className: (0, classnames_1.default)(c("input-wrapper"), (_a = {},
                        _a[c("input-wrapper", "in-agreement")] = _this.props.editor.schema.name === "agreement",
                        _a)) },
                    react_1.default.createElement(icons_1.Search, { className: c("input-icon") }),
                    react_1.default.createElement("input", __assign({}, rest, { className: c("input"), type: "text", onChange: (0, lodash_1.partial)(_this.handleInputChange, onChange), onKeyDown: (0, lodash_1.partial)(_this.handleInputKeyDown, onKeyDown), onBlur: (0, lodash_1.partial)(_this.handleInputBlur, onBlur) })))));
        };
        _this.getEntries = function (searchTerm) { return __awaiter(_this, void 0, Promise, function () {
            var tokens;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.props.searchTokens({ searchTerm: searchTerm })];
                    case 1:
                        tokens = _a.sent();
                        return [2, tokens.filter(Types_1.isNotPlatformProductToken).map(function (token) { return ({
                                value: token.id,
                                label: token.name,
                                data: token,
                            }); })];
                }
            });
        }); };
        _this.handleInputChange = function (onChange, event) {
            onChange(event.target.value);
        };
        _this.handleInputKeyDown = function (onKeyDown, event) {
            if (isDeleteKey(event.key) && isInputEmpty(event.target)) {
                event.preventDefault();
                event.stopPropagation();
                _this.handleOnCancel();
            }
            else {
                onKeyDown(event);
            }
        };
        _this.handleInputBlur = function (onBlur, event) {
            onBlur(event);
            if (!_this.hasTriggeredWidgetEvent) {
                _this.handleOnCancel();
            }
        };
        _this.handleOnSelect = function (entry) {
            if (_this.hasTriggeredWidgetEvent) {
                return;
            }
            _this.setHasTriggeredWidgetEvent();
            var _a = _this.props, widgetManager = _a.widgetManager, element = _a.element;
            widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent(EditorTypes_1.InlineType.Variable, {
                action: EditorTypes_1.VariableActionType.Insert,
                path: widgetManager.getPath(element),
                variable: entry.data,
            }));
        };
        _this.handleOnCancel = function () {
            if (_this.hasTriggeredWidgetEvent) {
                return;
            }
            _this.setHasTriggeredWidgetEvent();
            var _a = _this.props, widgetManager = _a.widgetManager, element = _a.element;
            widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent(EditorTypes_1.InlineType.Variable, {
                action: EditorTypes_1.VariableActionType.Cancel,
                path: widgetManager.getPath(element),
            }));
        };
        return _this;
    }
    TokenWidget.prototype.render = function () {
        var _this = this;
        var _a = this.props, startingSearchTerm = _a.startingSearchTerm, attributes = _a.attributes, children = _a.children;
        return (react_1.default.createElement("span", __assign({}, attributes, { className: c(), contentEditable: false }),
            react_1.default.createElement(kaleidoscope_1.Layer, { offset: 889 }, function () { return (react_1.default.createElement(LegacyCombobox_1.default, { autoStack: true, className: "token-widget__combobox-list", placeholder: "Find a token", label: "Search for tokens and add them inline", startingSearchTerm: startingSearchTerm, theme: "light", entries: _this.getEntries, onSelect: _this.handleOnSelect, onCancel: _this.handleOnCancel, renderEntry: _this.renderEntry, renderInput: _this.renderInput, autoFocus: true })); }),
            children));
    };
    TokenWidget = __decorate([
        mobx_react_1.observer
    ], TokenWidget);
    return TokenWidget;
}(react_1.default.Component));
exports.TokenWidget = TokenWidget;
var isDeleteKey = function (key) { return key === utils_1.KeyType.Delete || key === utils_1.KeyType.Backspace; };
var isInputEmpty = function (element) { return element.value === ""; };
